/**
 * 아직 서버에 없는 기능 — 백엔드 단계 계획에서 그 경로가 열리는 단계(백엔드 2단계 전달 §1 「아직 없는 것」 · §4-F).
 *
 * 화면은 이 표를 보고 단추를 「n단계에 열림」으로 잠그고, 상자는 서버를 부르지 않고 안내만 세운다.
 * 그 단계의 전달 문서를 받으면 그 줄을 지운다(창·상자 코드는 그대로 남아 있어 줄만 지우면 열린다).
 */
export const OPENS_AT = {
  // 반(목록 · 만들기 · 수정 · 비활성화 · 담임 · 시간표 · 학생 표의 반 · 담임 거르기)은 3단계에 열렸다(백엔드 3단계 전달 §4-F)
  // 반 편성(입반 · 반 이동 · 퇴반 · 편성 정정 · 삭제 · [학생 입반] · 새 학생 · 등록 때 반)은 4단계에 열렸다(백엔드 4단계 전달 §4-B)
  // 휴원 · 복귀 · 퇴원 · 퇴원일 변경 · 퇴원 예정 취소 · 휴원 기간 정정 · 삭제는 5단계에 열렸다(백엔드 5단계 전달 §4-A)
  // 현황 탭 상자(학년별 · 학교 × 학년) · 부서별 재원 막대는 6단계에 열렸다(백엔드 6단계 전달 §4-A)
  /** 출결 탭 · 출결 입력 · 반 상세의 최근 수업 · 출결 · 보강·추가 회차 */
  attendance: 7,
  /**
   * 직원 일정(E9 /staff-schedules) — 강사 숫자 띠의 「담임 부재 예정」 · 반 카드의 부재 표시. 서버에 아직 없고 여는 단계도 정하지 않았다
   * (백엔드 8단계 전달 §1 · §4-B). 값은 잠김 표시용일 뿐이다(화면은 단계 번호를 보이지 않는다)
   */
  staffSchedule: '미정',
};

/** 잠긴 기능이면 열리는 단계, 열렸으면 null */
export function lockedStage(feature) {
  return OPENS_AT[feature] ?? null;
}

/** 잠긴 단추 · 메뉴의 상태. 개발 단계는 사용자 화면에 표시하지 않는다. */
export const lockedLabel = () => '준비 중';
